import { get } from "../Config";

//GET
export function GetEventNewsList({ params = { limit: 10, offset: 0 } }) {
  return get({ url: `/api/koala/v1/eventNews`, params });
}
